import { AutogenModelFakProfileLookup, AutogenRowFakProfileLookup } from "./autogen/AutogenModelFakProfileLookup";

export class ModelFakProfileLookup extends AutogenModelFakProfileLookup<RowFakProfileLookup> {
	constructor() {
		super(RowFakProfileLookup);
	}
}

export class RowFakProfileLookup extends AutogenRowFakProfileLookup {
}